import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/warehouse/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const warehouse = {
  get: apiPathFunc(pathBase),
} as const;
